<template>
  <div>

    <h2 class="text-black">¡Ya formas parte <br> de Unipar Carreiras!</h2>
    <p class="h5 font-weight-normal mb-5">Su documento se encontró en nuestro socio <strong>99jobs.com</strong>. ¡Puede iniciar sesión con el mismo nombre de usuario y contraseña! Regrese al área de inicio de sesión para acceder a su cuenta. :)</p>

    <button class="btn btn-white d-flex align-items-center text-left border border-light-dark p-3 mx-auto" style="max-width: 320px;" @click="$emit('changeModal', 'login')">
      <img v-if="$store.state.deviseTrying.avatar" :src="$store.state.deviseTrying.avatar">
      <account-circle-icon v-else class="img text-blue-ml" />
      <div class="ml-3">
        <h5 class="m-0">{{ $store.state.deviseTrying.name }}</h5>
        <p class="m-0">Correo electrónico: {{ $helpers.censorEmail($store.state.deviseTrying.email) }}</p>
      </div>
    </button>

    <button class="btn btn-link d-flex align-items-center text-left p-0 mx-auto" @click.prevent="$emit('changeModal', 'forgotUser')">
      No tengo acceso a ese correo
    </button>

    <div class="text-center mt-5">
      <button type="submit" class="btn btn-blue-ml px-4" @click="$emit('changeModal', 'login')">Atrás para iniciar sesión</button>
    </div>

  </div>
</template>

<script>
  import AccountCircleIcon from "vue-material-design-icons/AccountCircle.vue";

  export default {
    name: 'UserExists',

    data(){
      return {
        cpf: ''
      }
    },

    components: {
      AccountCircleIcon
    },

    computed: {
    },

    methods: {
      hasNoAccess(){
        this.$swal({
          title: '¿No tienes acceso a ese correo electrónico?',
          html: '<p>Envíe un correo electrónico a <a href="mailto:suporte@99jobs.com">suporte@99jobs.com</a> informando su: <b>Documento</b>, <b>email registrado</b > y el <b>correo electrónico que desea utilizar</b> para que nuestro equipo de soporte pueda ayudarlo.</p>',
          type: 'info'
        }).then(() => this.$emit('changeModal', 'login'));
      }
    }
  }
</script>

<style lang="scss" scoped>
  img{
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
  }

  .img{
    font-size: 50px;
  }
</style>